import React, { createContext, useContext, useEffect, useRef, useState } from 'react'
import { keycloak, initOptions } from './keycloak'

const AuthContext = createContext(null)

export default function AuthProvider({ children }) {
  const [ready, setReady] = useState(false)
  const [authenticated, setAuthenticated] = useState(false)
  const initialized = useRef(false) // avoids React 18 StrictMode double-init

  useEffect(() => {
    if (initialized.current) return
    initialized.current = true

    keycloak
        .init(initOptions)
        .then((auth) => setAuthenticated(auth))
        .catch((err) => console.error('Keycloak init failed', err))
        .finally(() => setReady(true))

    // Optional: keep the token fresh automatically
    keycloak.onTokenExpired = () => {
      keycloak.updateToken(30).catch(() => {
        console.warn('Failed to refresh token, logging out')
        keycloak.logout()
      })
    }
  }, [])

  if (!ready) {
    return <div>Loading...</div>
  }

  return (
      <AuthContext.Provider value={{ keycloak, authenticated }}>
        {children}
      </AuthContext.Provider>
  )
}

export function useAuth() {
  return useContext(AuthContext)
}




// import React, { createContext, useState, useEffect } from "react";
// import keycloak from "./keycloak";

// export const AuthContext = createContext(null);
//
// export default function AuthProvider({ children }) {
//   const [isLoading, setIsLoading] = useState(true);
//
//   useEffect(() => {
//     keycloak
//       .init({
//         onLoad: "login-required",   // or "login-required"
//         checkLoginIframe: false,
//       })
//       .then(() => {
//         setIsLoading(false);
//
//         // Redirect after login
//         if (keycloak.authenticated) {
//           if (window.location.pathname === "/login") {
//             window.location.replace("/");
//           }
//         }
//       });
//   }, []); // 👈 EMPTY DEP ARRAY — runs ONCE
//
//   if (isLoading) return <>Loading...</>;
//
//   return (
//     <AuthContext.Provider value={{ keycloak }}>
//       {children}
//     </AuthContext.Provider>
//   );
// }
